import type { ButtonSize } from '~shared/ui/atoms';

import { ButtonSecondary } from '../Buttons/ButtonSecondary';

type Props = {
	children?: React.ReactNode;
	title: React.ReactNode;
	icon?: React.ReactNode;
	fullWidth?: boolean;
	selected?: boolean;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	size?: ButtonSize;
	disabled?: boolean;
};

export const GeneratorLabel = ({
	children,
	title,
	icon,
	fullWidth,
	selected,
	size = 'M',
	disabled,
	onClick,
}: Props) => (
	<ButtonSecondary
		fullWidth={fullWidth}
		leftIcon={icon}
		htmlFor={typeof title === 'string' ? title : undefined}
		selected={selected}
		size={size}
		disabled={disabled}
		onClick={onClick}
	>
		{title}
		{children}
	</ButtonSecondary>
);
